import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent {
  constructor(readonly route: ActivatedRoute, readonly router: Router) {
    this.route.queryParams.subscribe((params: any) => {
      this.utmSource = params['utm_source'];
    });
  }

  moveToPage(link: string, section: any) {
    this.router.navigate([link], {
      queryParams: {
        section: section,
      },
    });
    this.showMenu = false;
  }
  showMenu = false;
  listMenu = [
    {
      name: 'Wi-Fi 6',
      link: '/about-wifi-6',
    },
    {
      name: 'Ưu điểm',
      link: '/about-wifi-6',
      section: 'advantage',
    },
    {
      name: 'So sánh',
      link: '/compare-wifi-6',
    },
    {
      name: 'Câu hỏi thường gặp',
      link: '/about-wifi-6',
      section: 'qna',
    },
  ];
  utmSource: any;
  goToPage(str: string) {
    if (str === 'shop-fpt') {
      if (
        window.location.origin.includes('staging') ||
        window.location.origin.includes('localhost')
      ) {
        window.location.href =
          'https://shop-stag.fpt.vn/tin-tuc/trai-nghiem-wifi6';
      } else {
        window.location.href = 'https://shop.fpt.vn/tin-tuc/trai-nghiem-wifi6';
      }
    }
  }
  registerInfo() {
    this.router.navigate(['/swap-wifi-6'], {
      queryParams: { utm_source: this.utmSource },
    });
  }
}
